import { WHATSAPP_MESSAGES, whatsappUrl } from './site'

export interface Service {
  id: string
  label: string
  name: string
  supporting: string
  price?: string
  priceNote?: string
  includes: string[]
  highlight?: string
  cta: string
  /** Identificador de tracking (Meta Pixel se conectará más adelante). */
  analyticsId: string
  /** Enlace de WhatsApp con mensaje previo según el servicio. */
  href: string
  featured: boolean
}

export const services: Service[] = [
  {
    id: 'lanza-tu-empresa',
    label: '01 · Crear',
    name: 'Lanza tu Empresa',
    supporting:
      'La base que necesitas para comenzar tu negocio en Florida de forma profesional.',
    price: 'Desde $597',
    priceNote: 'Fee estatal de Florida incluido.',
    includes: [
      'LLC registrada en Florida (Sunbiz)',
      'EIN obtenido',
      'Logo profesional',
      'Email corporativo con dominio propio',
    ],
    highlight: 'Para quien está lista para transformar su idea en un negocio real.',
    cta: 'Quiero lanzar mi empresa',
    analyticsId: 'launch_business_whatsapp',
    href: whatsappUrl(WHATSAPP_MESSAGES.lanzaTuEmpresa),
    featured: true,
  },
  {
    id: 'presencia-digital',
    label: '02 · Construir',
    name: 'Presencia Profesional Digital',
    supporting:
      'Para negocios que ya existen o acaban de comenzar y necesitan una presencia digital profesional.',
    includes: [
      'Landing page o web estratégica',
      'Dominio propio configurado',
      'Email corporativo con dominio',
      'Optimización básica para Google',
    ],
    cta: 'Conocer esta opción',
    analyticsId: 'digital_presence_whatsapp',
    href: whatsappUrl(WHATSAPP_MESSAGES.presenciaDigital),
    featured: false,
  },
  {
    id: 'full-creation',
    label: '03 · Crecer',
    name: 'Inkova Full Creation',
    supporting:
      'Para quien quiere construir su negocio con estructura, identidad y presencia digital desde el comienzo.',
    includes: [
      'LLC registrada en Florida',
      'EIN obtenido',
      'Email corporativo con dominio',
      'Logo profesional',
      'Landing page o web estratégica',
      'Estrategia digital inicial',
    ],
    highlight: 'Todo lo esencial para construir tu negocio de forma conectada.',
    cta: 'Quiero construirlo todo',
    analyticsId: 'full_creation_whatsapp',
    href: whatsappUrl(WHATSAPP_MESSAGES.fullCreation),
    featured: false,
  },
]
